import { MiddlewareAPIResponse } from '../../middlewareapiresponse';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { ToneDto } from '../../../dto/tonedto';

export interface BannerSearchResponse extends MiddlewareAPIResponse
{
    getListOfSearchBannerDtos(): ToneDto[];
}

export class BannerSearchResponseDtoImpl extends MiddlewareDtoImpl implements BannerSearchResponse
{
    private bannerSearchDetailsResponseDtos : ToneDto[];

    getListOfSearchBannerDtos(): ToneDto[]
    {
        return this.bannerSearchDetailsResponseDtos;
    }
    setBannerSearchDto(bannerSearchDetailsRespnseDtos: ToneDto[])
    {
        this.bannerSearchDetailsResponseDtos = bannerSearchDetailsRespnseDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/bannersearch/bannersearchresponse.tsx